module.exports = __webpack_public_path__ + "static/media/caret-up.28457809.svg";